const topicList = [
  { name: '#偶像练习生2026', heat: '98.6万讨论', rank: 1 },
  { name: '#选秀天花板', heat: '87.3万讨论', rank: 2 },
  { name: '#真人秀名场面', heat: '76.8万讨论', rank: 3 },
  { name: '#爱豆舞台直拍', heat: '65.2万讨论', rank: 4 },
  { name: '#户外挑战王', heat: '58.9万讨论', rank: 5 },
  { name: '#综艺搞笑合集', heat: '52.4万讨论', rank: 6 },
  { name: '#偶像团体日常', heat: '46.7万讨论', rank: 7 },
  { name: '#旅行综艺治愈', heat: '41.3万讨论', rank: 8 },
  { name: '#音乐舞台纯享', heat: '38.1万讨论', rank: 9 },
  { name: '#新人选秀速递', heat: '33.5万讨论', rank: 10 },
  { name: '#幕后花絮揭秘', heat: '29.8万讨论', rank: 11 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          话题热榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          综艺爱好者最关注的实时热门话题
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {topicList.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-4 py-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-800 truncate">{item.name}</p>
                <p className="text-xs text-foreground-400">{item.heat}</p>
              </div>
              <i className="ri-arrow-right-up-line text-foreground-300 text-sm flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}